import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    BREADCRUMB: [
      { title: "مرکز آموزش‌های تخصصی" },
      { title: "دوره‌ها" },
    ],
    TITLE: "دوره‌ها",
    PLACEHOLDER: "عبارت خود را جستجو کنید...",
    DATE: "تاریخ برگزاری",
    SEE_MORE: "مطالعه بیشتر",
    FEEDBACK_FORM: "فرم بازخورد دوره",
    NOT_FOUND: "موردی یافت نشد!",
    SEARCH_RESULT: "نتایج جستجو",
    BACK_TO_LIST: "بازگشت به دوره های آموزشی",
  },
  [LOCALES.EN]: {
    BREADCRUMB: [
      { title: "Specialized Training Center" },
      { title: "Courses" },
    ],
    TITLE: "Courses",
    PLACEHOLDER: "Search...",
    DATE: "Date",
    SEE_MORE: "See More",
    FEEDBACK_FORM: "Course Feedback Form",
    NOT_FOUND: "Not Found!",
    SEARCH_RESULT: "Search Result",
    BACK_TO_LIST: "Back To Course List",
  },
} as const;

export default translation;
